module.exports = __webpack_public_path__ + "static/img/1738_phase_function_Paper_Points.af2c279.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1738_phase_function_Paper_Points.png
// module id = 0O8J
// module chunks = 0